


















import {Component, Prop, Vue} from "vue-property-decorator";
import VideoPlayerPoster from "@/components/atom/VideoPlayerPoster.vue";

@Component({
  components: {
    VideoPlayerPoster
  }
})
export default class BasicVideoPlayer extends Vue {
  public video: HTMLVideoElement;

  protected videoFileUrl: string = '';
  protected isShownPoster: boolean = true;
  protected isVideoBuffered: boolean = false;
  protected isPlaying: boolean = false;

  @Prop() videoUrl: string;
  @Prop() posterUrl: string;

  mounted (): void {
    this.$nextTick(() => {
      this.video = <HTMLVideoElement> this.$refs.video;
    });
  }

  public reset (): void {
    this.isPlaying = false;
    // バッファ中に閉じられる事を考慮してイベントリスナーを外す
    this.video.oncanplay = null;
    // ビデオが最後まで再生された際のイベントリスナーを外す
    this.video.onended = null;
    // ビデオを空にする
    this.videoFileUrl = '';
    // ポスターを表示状態に戻す
    this.isShownPoster = true;
  }

  public playVideo (): void {
    this.isPlaying = true;
    this.video.play();
  }

  public pauseVideo (): void {
    this.isPlaying = false;
    this.video.pause();
  }

  protected startVideo (): void {
    this.video.oncanplay = (): void => {
      this.video.oncanplay = null;
      this.isVideoBuffered = true;
      // ビデオが最後まで再生されたら頭に戻す
      this.video.onended = (): void => {
        this.video.currentTime = 0;
      };
      // BGMを消す
      this.$store.commit('pauseBgm');
      this.playVideo();
    };
    this.videoFileUrl = this.videoUrl;
    this.isShownPoster = false;
  }
}
